import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const ConstituionError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">We are sorry, currently we are offering digital outward remittance only to Resident Indians and NRE customers.</Text>
      <Text className="error-description">Please visit our nearest branch for more details.</Text>
    </Fragment>
  )
}

export default ConstituionError;
